<template>
  <v-autocomplete
    v-bind="$attrs"
    :items="availableItems"
    :label="label"
    v-model="selected"
    :search-input.sync="lookupText"
    @change="lookupText = ''"
    :loading="loading"
    :placeholder="placeholder"
    :item-text="itemText"
    item-value="ID"
    :clearable="clearable"
    :rules="rules"
    cache-items
    chips
    deletable-chips
    multiple
    dense
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-autocomplete>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
export default {
  name: 'autocomplete-search-multi-id-users',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: 'Users',
    },
    placeholder: {
      type: String,
      default: 'Start typing to search',
    },
    value: Array,
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: Array,
  },
  data() {
    return {
      //templateFIX: if there is more than one pick one to display
      itemText: 'FirstName',
      itemText: 'LastName',
      itemText: 'Email',
    }
  },
  watch: {
    value(nval, oval) {
      if (nval != oval) {
        this.lookupText = ''
      }
    },
  },
  computed: {
    ...get('user', ['users', 'loading']),
    ...sync('user', ['lookupText']),
    availableItems() {
      //if you have a property (like an IsActive boolean) you can change the true to filer i.e. i.IsActive
      var list = this.users.filter((i) => true)
      list.push({
        ID: 0,
        Email: 'Unassigned',
        FirstName: 'Unassigned',
        LastName: 'Unassigned',
        IsActive: true,
      })
      list = list.filter((i) => i.IsActive)
      // if existing record make sure the previous selection is available even if no longer active
      if (this.value > 0) {
        var selectedItem = this.users.find((i) => i.ID == this.value)
        if (!list.find((i) => i.ID == this.value) && selectedItem) {
          list.push(selectedItem)
        }
      }
      // sort by column
      list.sort((a, b) => {
        //set the property to sort on
        let textField = this.itemText
        let sort = a[textField] > b[textField] ? 1 : -1
        return sort
      })
      return list
    },
    selected: {
      get() {
        if (this.value && this.value.length > 0) {
          return this.value
        } else {
          return []
        }
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
  },
  created() {},
  methods: {},
}
</script>
<style></style>
